import { priorities } from "fleet/constant/custom-events";
import React from "react";
import { utcToLocalFormat } from "util/time";

function formatDate(date) {
  if (!date) {
    return null;
  }
  const format = "MMM Do, YYYY hh:mm:ss a";

  return utcToLocalFormat(date, format);
}

function formatResolvedStatus(resolved) {
  return resolved ? "Resolved" : "Unresolved";
}

function formatEventSeverity(priority) {
  return priorities[priority].label;
}

function formatTargetEvents(targetEvent) {
  if (!targetEvent) {
    return "";
  }

  return (
    <div key={targetEvent} className="label bg-aqua" title={targetEvent}>
      <span className="badge-label">{targetEvent}</span>
    </div>
  );
}

function formatSource(source) {
  if (!source) {
    return "Unknown Application";
  }

  return source.display_name;
}

export {
  formatDate,
  formatResolvedStatus,
  formatEventSeverity,
  formatTargetEvents,
  formatSource,
};
